import avatar from './avatar.png';
import home from './home.svg';
import dashboard from './dashboard.svg';
import group from './group.svg';
import settings from './settings.svg';
import successIcon from './successIcon.svg';
import vesselImage from './vesselImage.png';
import flag from './flag.png';
import loginBg from './loginBg.png';
import grayMARSLogo from './grayMARSLogo.svg';
import profilepic from './profilepic.png';
import vet from './vetsGraph.png';
import vessel from './vesselsGraph.png';
import dlr from './dlr.svg';
import VesselIcon from './VesselIcon.svg';
import toastWarnning from './toastWarnning.svg';
import toastError from './toastError.svg';
import avatarlg from './avatar-lg.png';
import avatarsm from './avatar-sm.png';
import successIconlg from './Tick-mark.svg';
import avatardrpdwn from './avatar-drpdwn.svg';
import openedeye from './eye-opened.svg';
import closedeye from './eye-closed.svg';
import vetRequestIcon from './VetRequest.svg';
import EmailIcon from './Email.svg';
import GraphIcon from './Graph.svg';
import ReportsIcon from './Reports.svg';
import doc from './doc.svg';
import docx from './docx.svg';
import jpeg from './jpeg.svg';
import jpg from './jpg.svg';
import pdf from './pdf.svg';
import png from './png.svg';
import xls from './xls.svg';
import xlsx from './xlsx.svg';
import successToastIcon from './toastSuccess.svg';
import warningToastIcon from './toastwarnningSmall.svg';
import errorToastIcon from './ToastErrorSmall.svg';
import noResults from './noresults.svg';
import stamp from './stamp.png';
import marsLogo from './marsLogo.png';
import accpetable from './Acceptable.png';
import acceptableOveride from './acceptableAmber.png';
import furtherInfoNeeded from './FurtherInfoNeeded.png';
import notAcceptableOveride from './notAcceptableAmber.png';
import notAcceptable from './notAcceptable.png';
import approved from './Approved.png';
import conditionallyApproved from './conditionallyApproved.png';
import notRecommended from './NotRecommended.png';
import recommended from './Recommended.png';
import rejected from './Rejected.png';
import copyIcon from './copy.png';
import arrival from './arrival.svg';
import departure from './departure.svg';
import aisGapStart from './ais-start-icon.svg';
import aisGapEnd from './ais-end-icon.svg';
import loiteringStart from './loitering-start.svg';
import loiteringEnd from './loitering-end.svg';
import stsStart from './stsStart.svg';
import stsEnd from './stsEnd.svg';
import pinIconRed from './pin-icon-red.svg';
import complianceList from './complianceList.svg';
import arrowSymbolRed from './arrow-symbol-red.svg';
import arrowSymbolBlue from './arrow-symbol-blue.svg';
import sanctionsCheck from './sanction-check.svg';
import portCallSymbol from './yellow-circle.svg';
import liveTracking from './live-tracking.svg';
import measuringTool from './measuring-tool.svg';
import vesselFilterIcon from './vessel-filter-icon.svg';
import distanceCalculatorIcon from './calculator-icon.svg';
import redCircle from './red-circle.svg';
import orangeCircle from './orange-circle.svg';
import vesselLiveTracking from './vessel-live-tracking.svg';
import watchList from './watch-list.svg';

export default {
  avatar,
  home,
  dashboard,
  group,
  settings,
  successIcon,
  vesselImage,
  flag,
  loginBg,
  grayMARSLogo,
  profilepic,
  vet,
  vessel,
  dlr,
  VesselIcon,
  toastWarnning,
  toastError,
  avatarlg,
  avatarsm,
  successIconlg,
  avatardrpdwn,
  openedeye,
  closedeye,
  vetRequestIcon,
  EmailIcon,
  GraphIcon,
  ReportsIcon,
  doc,
  docx,
  jpeg,
  jpg,
  pdf,
  png,
  xls,
  xlsx,
  successToastIcon,
  warningToastIcon,
  errorToastIcon,
  noResults,
  stamp,
  marsLogo,
  accpetable,
  acceptableOveride,
  furtherInfoNeeded,
  notAcceptableOveride,
  notAcceptable,
  approved,
  conditionallyApproved,
  notRecommended,
  recommended,
  rejected,
  copyIcon,
  arrival,
  departure,
  aisGapStart,
  aisGapEnd,
  loiteringStart,
  loiteringEnd,
  pinIconRed,
  stsStart,
  stsEnd,
  complianceList,
  arrowSymbolRed,
  arrowSymbolBlue,
  sanctionsCheck,
  portCallSymbol,
  liveTracking,
  measuringTool,
  vesselFilterIcon,
  distanceCalculatorIcon,
  redCircle,
  orangeCircle,
  vesselLiveTracking,
  watchList,
};
